import { Chip, lighten } from '@mui/material';
import { COVERAGE_STATUS_COLORS, getCoverageStatus } from 'modules/reports/constants/coverage-status.enum';
import { ICoverageListItem } from 'modules/reports/interfaces/IReportInventoryCoverage';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const CoverageStatusChip = ({ data }: { data: ICoverageListItem }) => {
  const { t } = useTranslation('report');
  const status = getCoverageStatus(data);
  const color = COVERAGE_STATUS_COLORS[status];

  return (
    <Chip
      label={t(`inventoryCoverage.buckets.${status}`)}
      sx={{
        backgroundColor: lighten(color, 0.8),
      }}
    />
  );
};

export default memo(CoverageStatusChip);
